export default "__VITE_ASSET__PIujZARz__"